"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranteeItemComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var utils_1 = require("./utils");
var GranteeIcons_1 = require("./GranteeIcons");
var Button_1 = require("../../../Button");
var granteeUserTitleRenderer = function (grantee, intl) {
    var userName = utils_1.getGranteeLabel(grantee, intl);
    if (grantee.status === "Inactive") {
        var inactiveLabel = " (" + intl.formatMessage({
            id: "shareDialog.share.grantee.item.user.inactive",
        }) + ")";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            userName,
            react_1.default.createElement("span", { className: "gd-grantee-content-label-inactive" }, inactiveLabel)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        userName,
        " ");
};
var GranteeUserItem = function (props) {
    var grantee = props.grantee, mode = props.mode, onDelete = props.onDelete;
    var intl = react_intl_1.useIntl();
    var onClick = react_1.useCallback(function () {
        onDelete(grantee);
    }, [grantee, onDelete]);
    var itemClassName = classnames_1.default({ "s-share-dialog-owner": grantee.isOwner, "s-share-dialog-current-user": grantee.isCurrentUser }, "gd-share-dialog-grantee-item", utils_1.getGranteeItemTestId(grantee));
    return (react_1.default.createElement("div", { className: itemClassName },
        grantee.isOwner ? (react_1.default.createElement(GranteeIcons_1.GranteeOwnerRemoveIcon, null)) : (react_1.default.createElement(GranteeIcons_1.GranteeRemoveIcon, { mode: mode, onClick: onClick })),
        react_1.default.createElement("div", { className: "gd-grantee-content" },
            react_1.default.createElement("div", { className: "gd-grantee-content-label" }, granteeUserTitleRenderer(grantee, intl)),
            react_1.default.createElement("div", { className: "gd-grantee-content-label gd-grantee-content-email" }, grantee.email)),
        grantee.status === "Active" ? react_1.default.createElement(GranteeIcons_1.GranteeUserIcon, null) : react_1.default.createElement(GranteeIcons_1.GranteeUserInactiveIcon, null)));
};
var GranteeUserInactiveItem = function (props) {
    var grantee = props.grantee;
    var intl = react_intl_1.useIntl();
    var granteeLabel = react_1.useMemo(function () {
        return utils_1.getGranteeLabel(grantee, intl);
    }, [grantee, intl]);
    var itemClassName = classnames_1.default("gd-share-dialog-grantee-item", "s-share-dialog-inactive-owner", utils_1.getGranteeItemTestId(grantee));
    return (react_1.default.createElement("div", { className: itemClassName },
        react_1.default.createElement(GranteeIcons_1.GranteeOwnerRemoveIcon, null),
        react_1.default.createElement("div", { className: "gd-grantee-content" },
            react_1.default.createElement("div", { className: "gd-grantee-content-label-inactive" }, granteeLabel),
            react_1.default.createElement("div", { className: "gd-grantee-content-label-inactive gd-grantee-content-inactive" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.item.user.inactive.description" }))),
        react_1.default.createElement(GranteeIcons_1.GranteeUserInactiveIcon, null)));
};
var GranteeGroupItem = function (props) {
    var grantee = props.grantee, onDelete = props.onDelete, mode = props.mode;
    var intl = react_intl_1.useIntl();
    var onClick = react_1.useCallback(function () {
        onDelete(grantee);
    }, [grantee, onDelete]);
    var groupName = react_1.useMemo(function () { return utils_1.getGranteeLabel(grantee, intl); }, [grantee, intl]);
    var numOfUsers = react_1.useMemo(function () {
        if (grantee.memberCount) {
            return intl.formatMessage({
                id: "shareDialog.share.grantee.item.users.count",
            }, { granteeCount: grantee.memberCount });
        }
    }, [grantee, intl]);
    var itemClassName = classnames_1.default("gd-share-dialog-grantee-item", utils_1.getGranteeItemTestId(grantee));
    return (react_1.default.createElement("div", { className: itemClassName },
        react_1.default.createElement(GranteeIcons_1.GranteeRemoveIcon, { mode: mode, onClick: onClick }),
        react_1.default.createElement("div", { className: "gd-grantee-content" },
            react_1.default.createElement("div", { className: "gd-grantee-content-label" }, groupName),
            numOfUsers && (react_1.default.createElement("div", { className: "gd-grantee-count-button" },
                react_1.default.createElement(Button_1.Button, { className: "gd-button-link-dimmed gd-button gd-grantee-content-user-count s-grantee-content-user-count", value: numOfUsers })))),
        react_1.default.createElement(GranteeIcons_1.GranteeGroupIcon, null)));
};
/**
 * @internal
 */
exports.GranteeItemComponent = function (props) {
    var grantee = props.grantee, mode = props.mode, onDelete = props.onDelete;
    if (grantee.type === "user") {
        return react_1.default.createElement(GranteeUserItem, { grantee: grantee, mode: mode, onDelete: onDelete });
    }
    else if (grantee.type === "inactive_owner") {
        return react_1.default.createElement(GranteeUserInactiveItem, { grantee: grantee });
    }
    else {
        return react_1.default.createElement(GranteeGroupItem, { grantee: grantee, mode: mode, onDelete: onDelete });
    }
};
//# sourceMappingURL=GranteeItem.js.map